<template>
    <div class="content-buttons">
        <y-panel>
            <y-loading
                :active="$wait.is('content-refresh-buttons')"
                height="170px"
            >
                <!-- Status -->
                <div
                    v-if="status !== 'new'"
                    class="content-status"
                    :class="[status]"
                >
                    {{ $t('content.status.title', [$t(`content.status.${status}`)]) }}
                </div>

                <div class="p20">
                    <!-- Publish -->
                    <y-button
                        v-if="has('publish')"
                        :key="`cp-${model}`"
                        color="blue"
                        block
                        size="lg"
                        loading-on="content-submitting-publish"
                        disabled-on="content-submitting"
                        @click.prevent="action(publishAction)"
                    >
                        {{ publishLabel }}
                    </y-button>

                    <div class="content-schedule">
                        <template v-if="has('schedule') && !isPublished">
                            <div class="button-group block mt10">
                                <y-button
                                    :key="`dpb-${model}`"
                                    disabled-on="content-submitting"
                                    @click.prevent="$refs.DatePicker.open()"
                                >
                                    {{ dateButtonLabel }}
                                </y-button>
                                <y-button
                                    v-if="model"
                                    :key="`dpb-clear-${model}`"
                                    block
                                    class="clear color-red"
                                    icon="md-close"
                                    disabled-on="content-submitting"
                                    @click.prevent="model = null"
                                />
                            </div>

                            <y-date-picker
                                ref="DatePicker"
                                v-model="model"
                                class="d-f mb0"
                                type="datetime"
                                no-label
                            />
                        </template>

                        <div
                            v-if="model || (form.published_at && form.published_by.id)"
                            class="content-schedule-value"
                        >
                            <span>
                                {{ $t('content.publish_date') }}
                                <y-date-label :element="dateLabelElement" />
                            </span>
                        </div>
                    </div>

                    <hr
                        v-if="has('draft') || has('delete')"
                        class="gray-lightest"
                    >

                    <!-- Draft -->
                    <y-button
                        v-if="has('draft')"
                        class="color-green"
                        block
                        loading-on="content-submitting-draft"
                        disabled-on="content-submitting"
                        @click.prevent="action('draft')"
                    >
                        {{ $t('button.draft') }}
                    </y-button>

                    <div
                        v-if="has('delete') || has('unpublish') || has('send') || has('reject')"
                        class="button-group mt10 block"
                    >
                        <!-- Delete -->
                        <y-button
                            v-if="has('delete')"
                            class="color-red"
                            loading-on="content-submitting-delete"
                            disabled-on="content-submitting"
                            @click.prevent="confirm('delete')"
                        >
                            {{ $t('button.delete') }}
                        </y-button>

                        <!-- Unpublish -->
                        <y-button
                            v-if="has('unpublish')"
                            class="color-orange"
                            loading-on="content-submitting-unpublish"
                            disabled-on="content-submitting"
                            @click.prevent="confirm('unpublish')"
                        >
                            {{ $t('button.unpublish') }}
                        </y-button>

                        <!-- Send -->
                        <y-button
                            v-if="has('send')"
                            class="color-blue"
                            loading-on="content-submitting-send"
                            disabled-on="content-submitting"
                            @click.prevent="action('send')"
                        >
                            {{ $t('button.send') }}
                        </y-button>

                        <!-- Reject -->
                        <y-button
                            v-if="has('reject')"
                            class="color-orange"
                            loading-on="content-submitting-reject"
                            disabled-on="content-submitting"
                            @click.prevent="confirmReject"
                        >
                            {{ $t('button.reject') }}
                        </y-button>
                    </div>

                    <template v-if="form.moderation_note">
                        <hr class="gray-lightest">
                        <div class="content-rejected">
                            <div class="title">
                                {{ $t('content.reject_title') }}
                            </div>
                            <p v-html="form.moderation_note" />
                        </div>
                    </template>
                </div>
            </y-loading>
        </y-panel>

        <y-post-confirm-modal
            ref="ConfirmModal"
            @confirm="action($event)"
        />
        <y-post-reject-modal
            ref="RejectModal"
            @confirm="reject($event)"
        />
    </div>
</template>

<script>

    import YDatePicker from '@deps/form/elements/DatePicker';
    import YDateLabel from '@deps/form/elements/DateLabel/DateLabel';
    import YPostConfirmModal from '../PostConfirmModal';
    import YPostRejectModal from '../PostRejectModal';

    export default {

        name: 'PostButtons',

        components: {
            YPostConfirmModal,
            YPostRejectModal,
            YDatePicker,
            YDateLabel,
        },

        props: {
            form: Object,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                model: null,

                // eslint-disable-next-line max-len
                text: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی است. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می‌طلبد تا با نرم‌افزارها شناخت بیشتری را برای طراحان رایانه‌ای علی‌الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می‌توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد. لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی است. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می‌طلبد تا با نرم‌افزارها شناخت بیشتری را برای طراحان رایانه‌ای علی‌الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می‌توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.',
            };
        },

        computed: {

            /**
             * Return buttons of form
             *
             * @returns {*}
             */
            buttons() {
                return this.get(this.form, 'buttons');
            },

            /**
             * Return status of form
             *
             * @returns {*}
             */
            status() {
                return this.get(this.form, 'status');
            },

            /**
             * Check if the post is published
             */
            isPublished() {
                return this.status === 'published' && this.form.published_at && this.form.published_by.id;
            },

            /**
             * Return label of the publish button
             */
            publishLabel() {
                if (!this.isPublished) {
                    return this.model
                        ? this.$t('button.publish_scheduled')
                        : this.$t('button.publish_now');
                }

                return this.$t('button.save');
            },

            /**
             * Return label of the publish button
             */
            publishAction() {
                if (!this.isPublished && this.model) {
                    return 'schedule';
                }

                return this.$t('publish');
            },

            /**
             * Return label of datepicker button
             */
            dateButtonLabel() {
                return this.model
                    ? this.$t('button.change_publish_date')
                    : this.$t('button.set_publish_date');
            },

            /**
             * Return date label format
             */
            format() {
                return this.$i18n.locale === 'fa'
                    ? 'DD MMMM YYYY - HH:mm'
                    : 'MMMM DD, YYYY - HH:mm';
            },

            /**
             * Date label element
             */
            dateLabelElement() {
                return {
                    value : this.model || this.form.published_at,
                    format: this.format,
                };
            },

        },

        /**
         * @inheritDoc
         */
        created() {
            this.model = null;
        },

        methods: {

            /**
             * Check if button is active
             *
             * @param button
             * @returns {boolean}
             */
            has(button) {
                return this.buttons.indexOf(button) > -1;
            },

            /**
             * Open confirm modal
             *
             * @param type
             */
            confirm(type) {
                this.$refs.ConfirmModal.open(type);
            },

            /**
             * Open reject modal
             */
            confirmReject() {
                this.$refs.RejectModal.open();
            },

            /**
             * Run the action
             *
             * @param type
             */
            action(type) {
                this.$emit('action', {
                    type,
                    published_at: this.model,
                });
            },

            /**
             * Run the action
             *
             * @param moderationNote
             */
            reject(moderationNote) {
                this.$emit('action', {
                    type           : 'reject',
                    moderation_note: moderationNote,
                });
            },

        },

    };

</script>
